module.exports = __webpack_public_path__ + "img/channel_background-1200w.4d29855f.png";